export enum ConfluenceSpaceType {
	ALL = 'ALL',
	ALL_EXCEPT_PERSONAL = 'ALL_EXCEPT_PERSONAL',
	ALL_EXCEPT_SPECIFIC = 'ALL_EXCEPT_SPECIFIC',
	PERSONAL = 'PERSONAL',
	SPECIFIC = 'SPECIFIC',
}
